// CSS
import "./BigPrimaryButton.css"

/** 
 * This component renders a big primary button with the available styles:
 * - default
 * - secondary
 * - light-grey
 * - dark-grey
 * - disabled
 * 
 * @param   {string} children The text displayed in the button.
 * @param   {string} buttonStyle The style to render the button in.
 * @param   {(e: React.MouseEvent) => void} onClick The function to call when the button is clicked.
 * @returns {ReactElement} A React element that renders a big primary button. 
 */
export default function BigPrimaryButton({children, buttonStyle, onClick}) {
    return (
        <button 
            className={`primary-button ${buttonStyle}`} 
            type="button" 
            onClick={onClick}
            disabled={buttonStyle === "disabled"}
        >
            {children}
        </button>
    )
}